import React from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@context/ModalsContext'

import { Body1, Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import { DocumentConfirmationModal } from './DocumentInfoPageStep1/modals/DocumentConfirmation.modal'

import styles from './DocumentsInfoPage.module.scss'

export const DocumentInfoPageStepPendingForm: React.FC<OuterProps> = (props) => {
  const { onSkipDocuments, handleSubmit } = props
  const { t } = useTranslation()

  const confirmSkipModal = useModal(DocumentConfirmationModal, { onConfirm: onSkipDocuments })

  return (
    <React.Fragment>
      <div>
        <Heading6 medium>{t('Sign up.Document Verification')}</Heading6>
        <Body1 isParagraph>
          {t(
            'Sign up.As a regulated entity we need these documents to verify who you are and where you live'
          )}
          :
        </Body1>

        <div className='pt-5'>
          <p className='content'>{t('Sign up.1. Proof of ID Document')}</p>
          <p className='content'>{t('Sign up.2. Proof of ID Address')}</p>
          <p className='content'>{t('Sign up.3. Proof of ID Residence Permit')}</p>
        </div>

        <div className='is-flex is-justify-content-center'>
          <div className={styles.button}>
            <Button.Secondary size='lg' fullWidth onClick={() => confirmSkipModal.open()}>
              {t('Skip')}
            </Button.Secondary>
            <Button.Primary size='lg' fullWidth onClick={handleSubmit}>
              {t('Submit')}
            </Button.Primary>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

interface OuterProps {
  onSkip(): void

  onSkipDocuments(): void

  handleSubmit(): void
}
